/**
 * @Description: 企业共享空间
 * @Date: 2020-5-29
 * @Modify:
 * @Author: ker
 */
// import Layout from '@/components/layout/Index.vue'

export default [
  {
    path: '/enterprise/guide',
    component: () => import('@/views/enterprise/Guide.vue')
  }
  // {
  //   path: '/enterprise',
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'privilege',
  //       component: () => import('@/views/enterprise/Privilege'),
  //       meta: { title: '权限管理', icon: 'home', noCache: true, keepAlive: false, auth: true }
  //     },
  //     {
  //       path: 'staff',
  //       name: 'space_staff',
  //       component: () => import('@/views/enterprise/staff/list.vue'),
  //       meta: { title: '员工资料库', icon: 'home', noCache: true, keepAlive: false, auth: true }
  //     },
  //     {
  //       path: 'staffdetail', // 企业员工空间（管理员查看具体某个员工的空间） R2 废弃  .........
  //       name: 'space_staff_detail',
  //       component: () => import('@/views/enterprise/staff/Detail.vue'),
  //       meta: { title: '员工资料库', icon: 'home', noCache: true, keepAlive: false, auth: true }
  //     },
  //     {
  //       path: 'share',
  //       name: 'space_share',
  //       component: () => import('@/views/enterprise/Share.vue'),
  //       meta: { title: '共享空间', icon: 'home', noCache: true, keepAlive: false, auth: true }
  //     },
  //     {
  //       path: 'recycle',
  //       name: 'space_recycle',
  //       component: () => import('@/views/enterprise/Recycle.vue'),
  //       meta: { title: '回收站', icon: 'home', noCache: true, keepAlive: false, auth: true }
  //     }
  //   ]
  // }
]
